import { defineComponent as S, ref as v, onMounted as B, openBlock as e, createElementBlock as t, createElementVNode as y, Fragment as u, renderList as b, normalizeClass as k, renderSlot as z, createVNode as w, toDisplayString as L } from "vue";
import M from "./index60.js";
const Y = { class: "gap-size-8 bg-bg-default flex w-full flex-col items-center" }, $ = { class: "gap-size-8 py-size-16 flex flex-row items-center justify-center" }, T = { class: "bg-bg-bg-innerframe p-size-8 gap-size-4 flex w-full flex-col rounded-[6px]" }, O = {
  key: 0,
  class: "h-10 w-full"
}, j = ["onClick"], I = ["onClick"], R = /* @__PURE__ */ S({
  __name: "BasePIN",
  props: {
    pin: {},
    pinLength: { default: 6 }
  },
  emits: ["key-press"],
  setup(a, { emit: E }) {
    const s = {
      BACKSPACE: "BACKSPACE",
      EMPTY: "EMPTY"
    }, g = a, m = E, x = () => {
      const _ = [...["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]].sort(() => Math.random() - 0.5), n = 2 * 4 + 3, c = Array.from({ length: 12 }, (l, i) => i).filter(
        (l) => l !== n
      ), f = c[Math.floor(Math.random() * c.length)], A = [];
      let K = 0;
      for (let l = 0; l < 3; l++) {
        const i = [];
        for (let p = 0; p < 4; p++) {
          const P = l * 4 + p;
          P === n ? i.push(s.BACKSPACE) : P === f ? i.push(s.EMPTY) : i.push(_[K++]);
        }
        A.push(i);
      }
      return A;
    }, h = v([]);
    B(() => {
      h.value = x();
    });
    const C = (o) => {
      if (o !== s.EMPTY) {
        if (o === s.BACKSPACE) {
          m("key-press", o);
          return;
        }
        g.pin.length >= g.pinLength || m("key-press", o);
      }
    };
    return (o, _) => (e(), t("div", Y, [
      y("div", $, [
        (e(!0), t(u, null, b(a.pinLength, (d, r) => (e(), t("div", {
          key: r,
          class: k([
            "w-size-16 h-size-16 rounded-pill",
            a.pin.length > r ? "bg-bg-primary border-bg-bg-outline border" : "bg-bg-bg-default border-bg-bg-outline border"
          ])
        }, null, 2))), 128))
      ]),
      z(o.$slots, "content"),
      y("div", T, [
        (e(!0), t(u, null, b(h.value, (d, r) => (e(), t("div", {
          key: `row-${r}`,
          class: "gap-size-4 grid grid-cols-4"
        }, [
          (e(!0), t(u, null, b(d, (n, c) => (e(), t(u, {
            key: `key-${r}-${c}`
          }, [
            n === s.EMPTY ? (e(), t("div", O)) : n === s.BACKSPACE ? (e(), t("button", {
              key: 1,
              type: "button",
              class: "bg-bg-bg-surface flex h-10 w-full items-center justify-center rounded-[4px]",
              onClick: (f) => C(n)
            }, [
              w(M, {
                name: "delete",
                size: "md",
                color: "var(--font-color-default)"
              })
            ], 8, j)) : (e(), t("button", {
              key: 2,
              type: "button",
              class: "bg-bg-bg-default border-bg-bg-outline text-font-18 text-default flex h-10 w-full items-center justify-center rounded-[4px] border",
              onClick: (f) => C(n)
            }, L(n), 9, I))
          ], 64))), 128))
        ]))), 128))
      ])
    ]));
  }
});
export {
  R as default
};
